import envConfig from "env.config.json";

const config = {
  ...envConfig.REACT_APP_VERTICALS["COMMON"],
  ...envConfig.REACT_APP_VERTICALS[process.env.REACT_APP_PLATFORM || "QUANTUM"],
};

export default config;
